import Flickity from 'flickity'

export default function testimonials () {
  const sliders = document.querySelectorAll('.page__testimonials__carousel')
  for (let i = 0; i < sliders.length; i++) {
    (function (el) {
      Flickity(el, {
        wrapAround: true,
        imagesLoaded: true,
        pageDots: true,
        prevNextButtons: false,
      })
    })(sliders[i])
  }
}
